export const DOCUMENT_REGISTER_TYPE_PATH = "/document-register/types/:typeId";
